import ApiError from '../api/ApiError';
import isPrimitiveType from './isPrimitiveType';

function unknownToString(err: unknown): string {
    if (err === null || typeof err === 'string') {
        return err ?? '';
    }

    if (isPrimitiveType(err)) {
        return String(err);
    }

    if (typeof err === 'object') {
        const maybeApiErrorWithMessage = err as { message?: string };
        if (maybeApiErrorWithMessage.message) {
            return maybeApiErrorWithMessage.message;
        }

        return JSON.stringify(err, null, 2);
    }

    return 'An unexpected error occurred.';
}

export default function unknownErrorToString(err: unknown): string {
    if (err instanceof ApiError) {
        let message = err.message;

        switch (err.status) {
            case 429:
                message += ' Too many requests. Please try again later.';
                break;
            // Handle other specific status codes here
            case 404:
                message += err.data
                    ? `: ${unknownToString(err.data)} 404 Not Found`
                    : ' 404 Not Found';
                break;
            default:
                message += err.data ? `: ${unknownToString(err.data)}` : '';
                break;
        }

        return message;
    }

    if (err instanceof Error) {
        return err.message;
    }

    return unknownToString(err);
}
